module.exports = __webpack_public_path__ + "static/img/icon-emptybox.276c05f0.png";